/** ຄິດໄລ່ຍອດອໍເດີ້ — subtotal ຈາກລາຍການຂາຍ (ບໍ່ລວມແຖມ) */
export function calculateOrderTotals(
  subtotal: number,
  discountAmount = 0,
  shippingFee = 0,
) {
  const safeSubtotal = Math.max(0, subtotal);
  const discount = Math.min(Math.max(0, discountAmount), safeSubtotal);
  const safeShipping = Math.max(0, shippingFee);
  const total = Math.max(0, safeSubtotal - discount) + safeShipping;

  return {
    subtotal: safeSubtotal,
    discountAmount: discount,
    shippingFee: safeShipping,
    total,
  };
}

export function orderLineKey(variantId: string, isBonus: boolean) {
  return `${variantId}:${isBonus ? "bonus" : "sale"}`;
}
